import React, { useState,useRef, useEffect } from 'react';
import { Box, Typography, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import EditorWindow from './EditorWindow';
import SendIcon from '@mui/icons-material/Send';
import { PlayArrow } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';


const CodeEditor = ({handleReset,handleRun,isLoading,handleSubmit,isSubmitLoading,codeTemplates,editorRef,handleMount,handleLanguageChange,height}) => {
  const observedDivRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (confirm) => {
    setOpen(false);
    if (confirm) {
      handleReset();
    }
  };
  
  
  
  return (

    <Box ref={observedDivRef} sx={{height:'100%'}}>   
            
      <Box
      sx={{
        backgroundColor: '#36343B',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        height: '55px',
        display: 'flex',
        alignItems: 'center',
        padding: '10px',
        
      }}
      >
        
        <Button              
          variant="text"              
          sx={{
            color: '#181719',
            height: '35px',                      
            borderBottom: '2px solid white' , 
            marginRight: '10px',
            borderRadius: '5px 5px 0 0',
            '&:hover': {
              backgroundColor: '#372D43', 
            },
          }}
        >
          <Typography sx={{ color: 'white' }}>code</Typography>
        </Button>
        
        
        <Box
          sx={{
            display:'flex',
            marginLeft: 'auto',
            marginRight:'10px',
            alignItems:'center',
            justifyContent:'center',
            width:'40px',
            '&:hover': {
                  backgroundColor: '#372D43',
                  cursor:'pointer',                   
                }

          }}
        >
          <RestartAltIcon
            sx={{
              color: 'white',
              height: '30px',
            }}
            onClick={handleClickOpen}
          />

        </Box>

        <Button 
        variant='contained'
        sx={{
          
          margin: '10px',
          backgroundColor:'black',
          '&:hover': {
            backgroundColor: 'gray', 
          },

        }}
        // endIcon={<SendIcon/>}
        onClick={()=>{
          handleRun();                 
          

        } }
        >

          {isLoading ? (
            <>
              <CircularProgress size={20} sx={{ color: 'white', marginRight: '5px' }} />
              <Typography sx={{ color: 'white',textTransform:'none' }}>Running...</Typography>
            </>
          ) : (
            <>
              <Typography sx={{ color: 'white' }}>Run</Typography>
              <PlayArrow sx={{ marginLeft: '5px', marginBottom: '2px', fontSize: '20px' }} />
            </>
          )}
        </Button>

        <Button 
        variant='contained'
        sx={{
          
          
          backgroundColor:'#0A5C36',
          '&:hover': {
            backgroundColor: '#0F5132', 
          },

        }}
        // endIcon={<SendIcon/>}
        onClick={()=>{
          handleSubmit();                 
          

        } }
        >

          {isSubmitLoading ? (
            <>
              <CircularProgress size={20} sx={{ color: 'white', marginRight: '5px' }} />
              <Typography sx={{ color: 'white',textTransform:'none' }}>Running...</Typography>
            </>
          ) : (
            <>
              <Typography sx={{ color: 'white' }}>Submit</Typography>
              <SendIcon sx={{ marginLeft: '5px', marginBottom: '2px', fontSize: '20px' }} />
            </>
          )}
        </Button>
      </Box>
      {codeTemplates && (
        <Box sx={{ height:'100%', backgroundColor: '#181719', borderRadius: '0px' }}>
          <Box >
            <EditorWindow  height = {height} editorRef={editorRef} handleMount={handleMount} languageChange={handleLanguageChange} codeTemplates={codeTemplates}/> 
          </Box>
        </Box>

      )}  

      <Dialog
        open={open}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: '#181719',
            borderRadius: '15px'
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <InfoIcon sx={{ color: '#5D2A79',ml:1, fontSize: 40, marginTop: '16px' }} />
          <Box sx={{padding:0}}>
            <DialogTitle id="alert-dialog-title" sx={{ color: 'white',paddingLeft:2 }}>
              {"Confirm Reset"}
            </DialogTitle>
            <DialogContent sx={{paddingLeft:2}}>
              <DialogContentText id="alert-dialog-description" sx={{ color: 'white' }}>
                Are you sure you want to reset your code?
              </DialogContentText>
            </DialogContent>
          </Box>
        </Box>
        <DialogActions>
          <Button 
            onClick={() => handleClose(false)} 
            sx={{
              color: 'white',
              fontSize:15,
              backgroundColor: 'transparent',              
              '&:hover': {
                backgroundColor: '#5D2A79',
              },
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={() => handleClose(true)} 
            color="primary"             
            sx={{
              color: 'white',
              fontSize:15,
              backgroundColor: 'transparent',              
              '&:hover': {
                backgroundColor: '#5D2A79',
              },
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>            
            
    </Box>     
              
            
          
          
    
  )
}

export default CodeEditor